module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/asignacion-manual/asignacion-manual.component.css
// module id = ./src/app/asignacion-manual/asignacion-manual.component.css
// module chunks = main